import React from 'react';

type InputTextBoxProps = {
    label: string;
    value: string;
    placeholder: string;
    id: string;
    required?: boolean;
    disabled?:boolean;
    width?:string;
    onChange: (id:string,newvalue:string,oldvalue:string|null) => void;
};

const InputTextBox: React.FC<InputTextBoxProps> = ({
    label,
    value,
    placeholder,
    id,
    required,
    disabled,
    width,
    onChange,
}) => {
    return (
        <div className="form-floating mb-3 me-3" style={{width:width?width:'400px'}}>
        <input type="text" className="form-control" id={id} placeholder={placeholder} required={required} value={value} disabled={disabled} onChange={(event)=>onChange(id,event.target.value,value)} />
        <label htmlFor={id}>{required?label+'*':label}</label>
      </div>
    );
};

export default InputTextBox;
